<template>
    <div class="right-pane">
        <div class="contains">
            <div class="top">
                <div class="alte-papi">
                    <!--                profile Pic-->
                    <img :src="getDataOnLogin.profileimage" alt="">
                    <!--                name-->
                    <div data-v-c1c52d9e="" class="name">
                        <p class="greetings">{{getDataOnLogin.customername | firstCaseCapitalSpace}}</p>
                        <!--                        <p class="lastLogin">lucaslumbex@hotmail.com</p>-->
                        <p class="lastLogin">{{getDataOnLogin.lastlogin}}</p>
                    </div>
                </div>
            </div>

            <!--            <hr >-->
            <div class="down">
                <!--                Search Bar-->
                <div class="search-hold">
                    <div class="search-bar">
                        <input type="text" placeholder="Search" v-model="rubiesSearch">
                        <i class="search-icon text-muted i-Magnifi-Glass1"></i>
                    </div>
                </div>

                <!--Results-->
                <div class="result">
                    <div v-if="filteredSearchCheck()">
                        <div>
                            <div v-for="rBook in filteredList">
                                <div v-if="rBook.accountname">
                                    <div class="media">
                                        <a @click="goToFastFundsTransfer(rBook)">
                                            <img :src="'https://s3.amazonaws.com/rubiesstore/'+ rBook.bankcode + '.png'">
                                            <div class="cont">
                                                <div v-if="rBook.alias === ''">
                                                    <p class="name">{{rBook.accountname | firstCaseCapitalSpace}}</p>
                                                </div>
                                                <div v-else>
                                                    <div v-if="rBook.alias.includes('Funds Transfer to')">
                                                        <p class="name">{{rBook.alias.replace(/Funds Transfer to/g,'') | firstCaseCapitalSpace}}</p>
                                                    </div>
                                                    <div v-else>
                                                        <p class="name">{{rBook.alias | firstCaseCapitalSpace}}</p>
                                                    </div>
                                                </div>
                                                <!--<p v-if="rBook.alias === ''" class="name">{{rBook.accountname | firstCaseCapitalSpace}}</p>-->
                                                <!--<p v-else class="name">{{rBook.alias | firstCaseCapitalSpace}}</p>-->
                                                <p class="number">{{rBook.accountnumber}} - {{rBook.bankname | firstCaseCapitalSpace}}</p>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="media empty">
                                        <p>
                                            Ooops!! No Result..
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="media empty">
                            <p>
                                Ooops!! No Result..
                            </p>
                        </div>
                    </div>
                </div>



                <!--Quick Transfer Modal-->
                <ui-modal
                        ref="quickTransferModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="quickTransferModalHide"
                        align-top :align-top-margin="150"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body history">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="quickTransfer">
                                            <div class="account-info">
                                                <p class="alias">{{currentQuickTransfer.alias}}</p>
                                                <p class="name">{{currentQuickTransfer.accountname}}</p>
                                                <p class="account">
                                                    {{currentQuickTransfer.accountnumber+ ' ' +currentQuickTransfer.bankname}}
                                                </p>
                                            </div>

                                            <div class="quickTransferForm">
                                                <div class="alert-box">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                                {{alert.message}}
                                                            </ui-alert>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12 form-group mb-2">
                                                        <label class="form-label">Debit Account*</label>
                                                        <ui-select
                                                                ref="debitAccountSelect"
                                                                placeholder="Select Debit Account"
                                                                type="basic"
                                                                :options="dat"
                                                                v-model="debitAcct"
                                                        ></ui-select>
                                                    </div>

                                                    <div class="col-sm-12 form-group mb-2">
                                                        <label for="amount" class="form-label">Amount*</label>
                                                        <div class="amount-input">
                                                            <div class="currency">
                                                                <span>&#8358;</span>
                                                            </div>

                                                            <input
                                                                    type="text" id="amount" class="input"
                                                                    value="" data-type="currency" placeholder="Amount" data-vv-name="Amount"
                                                                    v-model="amount" name="amount" v-on:keypress="isNumber($event)" required
                                                                    @change="amountOnChange(amount)"
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="confirmQuickTransfer()" class="btn btn-primary btn-xnax-login ">Next</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'


    export default {
        name: "LeftBar",
        components: { },
        props: { },
        data () {
            return {
                rubiesSearch: '',

                currentQuickTransfer: '',

                debitAcct:  '',
                debitAcctTouched:  false,
                amount: '',

                dat: [],

                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getDataOnLogin',
            ]),

            filteredList() {
                return this.getDataOnLogin.ftbeneficiaries.filter(rBook => {
                    let tempRBook;
                    tempRBook = rBook.accountname.toLowerCase().includes(this.rubiesSearch.toLowerCase());
                    tempRBook = tempRBook + rBook.alias.toLowerCase().includes(this.rubiesSearch.toLowerCase());
                    tempRBook = tempRBook + rBook.accountnumber.toLowerCase().includes(this.rubiesSearch.toLowerCase());
                    tempRBook = tempRBook + rBook.bankname.toLowerCase().includes(this.rubiesSearch.toLowerCase());
                    return tempRBook;
                })
            },
        },
        created () {
            this.popDebitAcct()
        },
        methods: {
            ...mapActions([
                'updateSideBarPage',
                'updateConfirmationPageBody',
                'updateInsideCurrentPage',
            ]),

            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },

            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            popDebitAcct(){
                let sdat = [];
                let sample = {};

                for (let i = 0; i < this.getDataOnLogin.accountlist.length; i++){

                    if (this.getDataOnLogin.accountlist[i].account_type === 'IBANKER'){
                        // console.log('I Banker Account')
                    } else {
                        sample.label = this.getDataOnLogin.accountlist[i].accountno + " - ₦" + this.$options.filters.moneyFormat(this.getDataOnLogin.accountlist[i].availablebalance);
                        sample.value = this.getDataOnLogin.accountlist[i];

                        sdat.push(sample)

                        sample = {}
                    }
                }
                this.dat = sdat;
            },

            amountOnChange(_incomingAmount){
                if(_incomingAmount.length === 0){
                    _incomingAmount = '0'
                }
                // _incomingAmount = _incomingAmount.replace(/,/g, '');

                let outgoingAmount = this.cleanAmount(_incomingAmount);
                let indexOfThePoint = outgoingAmount.indexOf('.');

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    return string + this;
                };
                let answer = outgoingAmount
                let count = 0
                for (let i = indexOfThePoint; i >= 1; i--){
                    if(count === 3){
                        count = 1
                        answer = answer.insert(i, ",")
                    }
                    else {
                        count++
                    }
                }

                this.amount = answer;
            },
            cleanAmount(_amount){
                _amount = _amount.replace(/,/g, '');
                _amount = (parseFloat(_amount).toFixed(2)).toString();

                return _amount
            },

            resetRubiesSearch(){
                this.rubiesSearch = ''
            },
            filteredSearchCheck(){
                return this.filteredList.length > 0;
            },

            goToFastFundsTransfer(_person){
                // console.log('Fast Transfer Person', _person)

                this.currentQuickTransfer = _person

                //Show Success Modal and then redirect to the home page / login page
                this.openModal('quickTransferModal');
            },


            quickTransferModalHide(){
                // change the currentComponent in the store to 'dashboard'
                // console.log('Quick Transfer Modal Close')
                this.amount = '';
                this.debitAcct = ''
            },

            confirmQuickTransfer(){
                if (this.debitAcct === undefined || this.debitAcct === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Debit Account*')
                }
                else if(this.amount === undefined || this.amount === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Enter Amount*')
                }
                else {
                    let creditBank = {
                        bankcode: this.currentQuickTransfer.bankcode,
                        bankname: this.currentQuickTransfer.bankname,
                        nubancode: ""
                    }
                    //    prepare the post Body
                    let pastBody ={
                        debitAcct:  this.debitAcct.value,
                        creditBank: creditBank,
                        creditAccount: this.currentQuickTransfer.accountnumber,
                        amount: this.amount,
                        showNarration: true,
                        confirmationType: 'SEND MONEY CONFIRMATION',
                        confirmationTypeSub: 'Quick Transfer',
                        transactionType: 'fundsTransfer',
                        creditAccountName: this.currentQuickTransfer.accountname,
                        narration: 'Transfer from ' + this.debitAcct.value.accountname + ' to ' + this.currentQuickTransfer.accountname,
                    }

                    this.closeModal('quickTransferModal');

                    //    Save Details in the Store for Name Enquiry
                    this.updateConfirmationPageBody(pastBody);

                    // console.log('final PAST Body', pastBody);

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('confirmation')
                }
            },
        },
        mounted(){
            this.$nextTick(()=>{})
        },
    }
</script>

<style scoped>
.account-info {
    padding: 0 0 15px 13px;
}
.account-info .alias {
    font-size: 8px !important;
    color: #808181;
}
.account-info .name {
    font-size: 14px !important;
    text-transform: uppercase;
    font-weight: 600;
    line-height: 14px;
    margin-bottom: 3px !important;
    margin-top: 2px;
}
.account-info .account {
    font-size: 10px !important;
    line-height: 10px;
    color: #6d0606;
}

</style>